const parseCSS = (css) => {
    const rules = [];
    let currentRule = "";
    let braceCount = 0;
    for (let i = 0; i < css.length; i++) {
        const char = css[i];
        currentRule += char;
        if (char === "{") {
            braceCount++;
        }
        else if (char === "}") {
            braceCount--;
            if (braceCount === 0) {
                rules.push(currentRule.trim());
                currentRule = "";
            }
        }
    }
    return rules;
};
const processAtRule = (rule, scopeId) => {
    if (!rule.match(/^@(media|supports|container)/)) {
        return rule;
    }
    const match = rule.match(/^(@[^{]+)\{([\s\S]*)\}$/);
    if (!match) {
        return rule;
    }
    const [, atRule, content] = match;
    const scopedContent = generateScopedCSS(content, scopeId);
    return `${atRule} { ${scopedContent} }`;
};
const scopeSingleSelector = (sel, scopePrefix) => {
    sel = sel.trim();
    if (sel === ":root" || sel === "html" || sel === "body") {
        return scopePrefix;
    }
    if (sel.startsWith(":")) {
        return `${scopePrefix}${sel}`;
    }
    if (sel.includes(scopePrefix)) {
        return sel;
    }
    return `${scopePrefix} ${sel}`;
};
const processRegularRule = (rule, scopeId) => {
    const scopePrefix = `#${scopeId}`;
    const match = rule.match(/^([^{]+)\{([^}]*)\}$/);
    if (!match) {
        return rule;
    }
    const [, selector, declarations] = match;
    const scopedSelectors = selector
        .split(",")
        .map(sel => scopeSingleSelector(sel, scopePrefix))
        .join(", ");
    return `${scopedSelectors} {${declarations}}`;
};
const processRule = (rule, scopeId) => {
    if (rule.startsWith("@")) {
        return processAtRule(rule, scopeId);
    }
    return processRegularRule(rule, scopeId);
};
export const generateScopedCSS = (css, scopeId) => {
    const rules = parseCSS(css);
    return rules
        .map(rule => processRule(rule, scopeId))
        .join("\n");
};
export const generateScopedCSSAlt = (css, scopeId) => {
    const processors = {
        atRule: (rule) => processAtRule(rule, scopeId),
        regularRule: (rule) => processRegularRule(rule, scopeId)
    };
    const getRuleType = (rule) => rule.startsWith("@") ? "atRule" : "regularRule";
    const rules = parseCSS(css);
    const processedRules = rules.map(rule => {
        const type = getRuleType(rule);
        return processors[type](rule);
    });
    return processedRules.join("\n");
};
